import React, { useState } from "react";
import { Helmet } from "react-helmet";
import GenerateHomePageLinks from "../HomePageLinks/HomePageLinks";
import { MASTER_JOB_LABELS } from "../config/masterJobsApi";

const resultTips = [
  "Check your roll number and personal details carefully on the result page.",
  "Look for scorecards, merit lists, cutoffs, or next-stage instructions.",
  "Keep a copy of the official result or scorecard for future use.",
];

const ResultsPage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="page-container">
      <Helmet>
        <title>{`Free Latest Results ${new Date().getFullYear()} | AAMSchool`}</title>
        <link rel="canonical" href="https://www.aamschool.in/results" />
        <meta
          name="description"
          content="Browse free exam and recruitment result updates, score notices, and related alerts on AAMSchool."
        />
        <meta property="og:title" content={`Free Latest Results ${new Date().getFullYear()} | AAMSchool`} />
        <meta
          property="og:description"
          content="Browse free exam and recruitment result updates, score notices, and related alerts on AAMSchool."
        />
        <meta property="og:url" content="https://www.aamschool.in/results" />
        <meta property="og:type" content="website" />
      </Helmet>
      <h1>Latest Results {new Date().getFullYear()}</h1>
      <p className="page-lead">
        This page brings together recent exam and recruitment result updates. It is useful for
        candidates who want to track announcements, check score availability, and understand what
        step comes next after the result is declared.
      </p>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search jobs, admit card, result..."
          className="global-search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <GenerateHomePageLinks
        label={MASTER_JOB_LABELS.latestResults}
        header="Latest Results"
        searchTerm={searchTerm}
        showAllItems
        layoutVariant="page"
      />

      <section className="page-info-grid" aria-label="Result guidance">
        <article className="page-info-card">
          <h2>After Checking Your Result</h2>
          <ul className="page-info-list">
            {resultTips.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
        <article className="page-info-card">
          <h2>Why Verification Matters</h2>
          <p>
            Result pages often include important next steps such as document verification, interview
            schedules, counseling, or joining instructions. Always open the official notice after
            finding the update here.
          </p>
        </article>
      </section>
    </div>
  );
};

export default ResultsPage;
